import React from 'react';

import { DescriptionStyled } from './styles';

type Props = {
  children: JSX.Element | JSX.Element[];
};

const Description = ({ children }: Props): JSX.Element => {
  return <DescriptionStyled>{children}</DescriptionStyled>;
};

export default Description;
